import { createApp } from 'vue'
import { createWebHashHistory, createRouter } from 'vue-router'
import '../node_modules/semantic-ui-css/semantic.min.css'
import App from './App.vue'

import Feed from './routes/Feed.vue'
import News from './routes/News.vue'

const routes = [
  {
    path: '/',
    redirect: '/headlines'
  },
  {
    path: '/:feed',
    name: 'Feed',
    component: Feed
  },
  {
    path: '/:feed/:id',
    name: 'News',
    component: News
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  linkExactActiveClass: 'active',
  routes: routes
})

const app = createApp(App)
app.use(router)
app.mount('#app')

